import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2dbea1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "register-test-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_navigation = _resolveComponent("base-navigation")!
  const _component_test_instructions_StepOne = _resolveComponent("test-instructions-StepOne")!
  const _component_test_instructions_StepTwo = _resolveComponent("test-instructions-StepTwo")!
  const _component_test_instructions_StepThree = _resolveComponent("test-instructions-StepThree")!
  const _component_test_instructions_StepFour = _resolveComponent("test-instructions-StepFour")!
  const _component_test_instructions_StepFive = _resolveComponent("test-instructions-StepFive")!
  const _component_test_instructions_StepSix = _resolveComponent("test-instructions-StepSix")!
  const _component_test_instructions_StepSeven = _resolveComponent("test-instructions-StepSeven")!
  const _component_base_footer = _resolveComponent("base-footer")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_navigation, { selectedStep: _ctx.getActiveStep }, null, 8, ["selectedStep"]),
      _withDirectives(_createVNode(_component_test_instructions_StepOne, {
        ref: "step-1",
        active: _ctx.activeStep == 1,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 1]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepTwo, {
        ref: "step-2",
        active: _ctx.activeStep == 2,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 2]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepThree, {
        ref: "step-3",
        active: _ctx.activeStep == 3,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 3]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepFour, {
        ref: "step-4",
        active: _ctx.activeStep == 4,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 4]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepFive, {
        ref: "step-5",
        active: _ctx.activeStep == 5,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 5]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepSix, {
        ref: "step-6",
        active: _ctx.activeStep == 6,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 6]
      ]),
      _withDirectives(_createVNode(_component_test_instructions_StepSeven, {
        ref: "step-7",
        active: _ctx.activeStep == 7,
        onPreviousStep: _ctx.previousStep,
        onNextStep: _ctx.nextStep
      }, null, 8, ["active", "onPreviousStep", "onNextStep"]), [
        [_vShow, _ctx.activeStep == 7]
      ]),
      (!_ctx.hideFooter)
        ? (_openBlock(), _createBlock(_component_base_footer, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.Loader)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, {
          key: 0,
          class: "loader"
        }))
      : _createCommentVNode("", true)
  ], 64))
}